import React from 'react';
import { connect, useSelector } from 'react-redux';
import { getVariantsModel } from 'features/product-info/ducks/selectors';
import type { CommonlyExcludedHTMLAttributeNames, HTMLAttributes } from 'types/utils';
import { Dispatch } from 'redux';
import { VARIANT_ITEM_CLICK } from 'common/components/product-variants/ducks/actions';
import { Variant } from './components/multi-axis-dropdown/components/variants-drawer-content/variant-axis/utils/types';
import { ColorCarousel, MultiAxisDropdown, SingleAxisDropdown } from './components';
import { AxisPoint } from './types';

type PdpVariantsProps = { onVariantClick: (ap: AxisPoint) => void } & Omit<
  HTMLAttributes,
  CommonlyExcludedHTMLAttributeNames
>;

export const Variants: React.FC<PdpVariantsProps> = ({ onVariantClick }) => {
  const variantsModelContainer = useSelector(getVariantsModel);
  const { variantsModel, activePoint } = variantsModelContainer ?? {};

  if (variantsModel && variantsModel.length === 1) {
    return variantsModel[0].asImageThumb ? (
      <ColorCarousel
        variantsModel={variantsModel}
        activePoint={activePoint}
        onVariantClick={onVariantClick}
      />
    ) : (
      <SingleAxisDropdown
        variantsModel={variantsModel}
        activePoint={activePoint}
        onVariantClick={onVariantClick}
      />
    );
  }
  if (variantsModel && variantsModel.length > 1) {
    return <MultiAxisDropdown variantsModel={variantsModel} activePoint={activePoint} />;
  }
};
export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onVariantClick: (payload: Variant) => dispatch(VARIANT_ITEM_CLICK(payload)),
});

export const PdpVariants = connect(null, mapDispatchToProps)(Variants);
